import React, { useState, useEffect, useRef } from 'react';
import './IntroVideoModal.scss';
import introVideo from '../../assets/clips/klyx-intro2.mp4';

interface IntroVideoModalProps {
  storageKey?: string;
}

export const IntroVideoModal: React.FC<IntroVideoModalProps> = ({
  storageKey = 'klyx-intro-dismissed'
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    // Check if user has dismissed the intro
    const dismissed = localStorage.getItem(storageKey);
    if (!dismissed) {
      setIsVisible(true);
    }
  }, [storageKey]);

  const handleSkip = () => {
    setIsVisible(false);
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handleDontShowAgain = () => {
    localStorage.setItem(storageKey, 'true');
    setIsVisible(false);
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handleVideoEnd = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="intro-video-modal">
      <div className="intro-video-backdrop" onClick={handleSkip} />
      <div className="intro-video-container">
        <video
          ref={videoRef}
          className="intro-video"
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnd}
          controls={false}
        >
          <source src={introVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="intro-video-controls">
          <button
            className="intro-video-btn intro-video-btn-skip"
            onClick={handleSkip}
          >
            Skip
          </button>
          <button
            className="intro-video-btn intro-video-btn-dismiss"
            onClick={handleDontShowAgain}
          >
            Don't Show Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntroVideoModal;
